
export function AdminFooter() {
    return (
        <footer className="bg-[#2C2731] text-white py-12 px-6 lg:px-32">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
                    <div className="flex items-start">
                        <img src="/gclogo.png" alt="Guides Collective" className="h-10 w-auto" />
                    </div>

                    <div>
                        <h3 className="text-lg font-bold mb-4">Admin Links</h3>
                        <ul className="space-y-2 text-sm opacity-80">
                            <li>
                                <a href="/admin" className="hover:opacity-100 transition-opacity">
                                    Dashboard
                                </a>
                            </li>
                            <li>
                                <a href="/admin/guides" className="hover:opacity-100 transition-opacity">
                                    Manage Guides
                                </a>
                            </li>
                            <li>
                                <a href="/admin/seekers" className="hover:opacity-100 transition-opacity">
                                    Manage Seekers
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-bold mb-4">Support</h3>
                        <div className="space-y-2 text-sm opacity-70">
                            <a href="mailto:support@guidescollective.com" className="hover:opacity-100 transition-opacity">
                                support@guidescollective.com
                            </a>
                            <p>Mon–Fri, 9am–6pm ET</p>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-lg font-bold mb-4">Resources</h3>
                        <div className="flex flex-col gap-2 text-sm opacity-80">
                            <a href="/privacypolicy" className="hover:opacity-100 transition-opacity">
                                Privacy Policy
                            </a>
                            <a href="/terms/full" className="hover:opacity-100 transition-opacity">
                                Terms of Use
                            </a>
                            <a href="/docs" className="hover:opacity-100 transition-opacity">
                                Documentation
                            </a>
                        </div>
                    </div>
                </div>

                <div className="border-t border-white/15 mb-6"></div>

                <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm opacity-75">
                    <p className="text-center">© 2025 Guides Collective Admin · All Rights Reserved</p>
                    <a href="/security" className="underline hover:opacity-100 transition-opacity">
                        Security
                    </a>
                    <a href="/status" className="underline hover:opacity-100 transition-opacity">
                        System Status
                    </a>
                </div>
            </div>
        </footer>
    );
}
